import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";
import "./Content.css";
import "./Achivement.css";
import achTopIcon from "../../asset/newImg/ach.png";
import bullet_icon from "../../asset/bullet_icon.svg";
import achv1 from "../../asset/achv1.jpeg";
import achv2 from "../../asset/achv2.jpg";
import achv3 from "../../asset/achv3.jpg";
import achv4 from "../../asset/achv4.jpg";
import { Col, Row } from "react-bootstrap";
import Slider from "react-slick";

function Achievements(props) {
  const { cover, sidebar_data, side_heading, side_sub_heading } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    console.log("asd");
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };


  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const images = [
    achv1,
    achv2,
    achv3,
    achv4,
    
  ];

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`}>
            Achievements & Laurels
          </div>
          <div>
            <div className="d-flex gap-2 mt-1">
              <div className="container">
                <div className="color-grey f-500">
                  Herman Gmeiner School proudly highlights its achievements and
                  presents the best of its students, whether they are excelling
                  academically, athletically or in service to the community. We
                  hope to inspire more students to excel, their achievements
                  ultimately make the school become stronger.By highlighting
                  student achievements, we aim to eliminate self-doubt and build
                  confidence in our students that hard work is important and is
                  making an impact. In turn, this confidence can carry over to
                  other facets of their young lives, including making smart
                  choices when faced with several challenges as they grow up.
                </div>



                <div className="achievement_section mt-5">
                  <div className="achievement_content row">
                    <div className="col-lg-6 achiecontent">
                      <h2 className="section_titless">School’s Achievements</h2>
                      <ul>
                        <li>Got North Zone Library Award by foot4thought in year 2019</li>
                        <li>Km. Savita got first position in the Mewat District.</li>
                        <li>Master Yogesh (Class 8th), Km. Shreya(Class 10th) got second position</li>
                        <li>Km. Saniya(Class 8th), Master Parvez(Class 8th), Km. Saafiya(Class 8th), and Km. Anjali (Class 10th) got third position.</li>
                        <li>Our school girls participated in District level Independence Day celebration on 15th August 2022 organized by district administration.</li>
                        <li>Our school girls got second position in action song and got trophy.</li>
                      </ul>
                    </div>
                    <div className="col-lg-6 achieveimage">
                      <img
                        className="col-md-12 mt-5"
                        style={{ marginTop: "1rem" }}
                        src={achv4}
                      />
                    </div>
                  </div>
                </div>


                <div className="container py-4 silderac">
                  <h2 className="fw-bold text-center mb-4">Awards Gallery</h2>

                  <Slider {...settings}>
                    {images.map((img, i) => (
                      <div key={i} className="img-slide-wrapper">
                        <img src={img} alt="gallery" className="slider-img" />
                      </div>
                    ))}
                  </Slider>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Achievements;
